import { render, staticRenderFns } from "./GolstatsDataGS2.vue?vue&type=template&id=40b81302&scoped=true&"
import script from "./GolstatsDataGS2.vue?vue&type=script&lang=js&"
export * from "./GolstatsDataGS2.vue?vue&type=script&lang=js&"
import style0 from "./GolstatsDataGS2.vue?vue&type=style&index=0&id=40b81302&prod&lang=css&"
import style1 from "./GolstatsDataGS2.vue?vue&type=style&index=1&id=40b81302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b81302",
  null
  
)

export default component.exports